import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/Reportes.css';

const Reportes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [busqueda, setBusqueda] = useState('');

  // Obtener el tenant slug de la URL
  const getTenantSlug = () => {
    const pathParts = location.pathname.split('/');
    return pathParts[1] || '';
  };

  const tenantSlug = getTenantSlug();

  const reportes = [
    {
      id: 'pagos-prestamos',
      titulo: 'Pagos por Préstamos',
      descripcion: 'Ver todos los pagos realizados por préstamo',
      icono: '💰',
      ruta: `/${tenantSlug}/reportes/pagos-prestamos`,
      categoria: 'Pagos'
    },
    {
      id: 'historial-prestamos',
      titulo: 'Historial de Préstamos',
      descripcion: 'Historial completo de préstamos por cliente',
      icono: '📋',
      ruta: `/${tenantSlug}/reportes/historial-prestamos`,
      categoria: 'Préstamos'
    },
    {
      id: 'estado-cuenta',
      titulo: 'Estado de Cuenta',
      descripcion: 'Estado de cuenta detallado de clientes',
      icono: '📊',
      ruta: `/${tenantSlug}/reportes/estado-cuenta`,
      categoria: 'Clientes'
    },
    {
      id: 'incobrables',
      titulo: 'Incobrables',
      descripcion: 'Préstamos marcados como incobrables',
      icono: '⚠️',
      ruta: `/${tenantSlug}/reportes/incobrables`,
      categoria: 'Préstamos'
    },
    {
      id: 'ingresos-egresos',
      titulo: 'Ingresos y Egresos',
      descripcion: 'Reporte de ingresos y egresos del negocio',
      icono: '💵',
      ruta: `/${tenantSlug}/reportes/ingresos-egresos`,
      categoria: 'Finanzas'
    },
    {
      id: 'ingresos-capital',
      titulo: 'Ingresos y Capital',
      descripcion: 'Análisis de ingresos y capital disponible',
      icono: '💼',
      ruta: `/${tenantSlug}/reportes/ingresos-capital`,
      categoria: 'Finanzas'
    },
    {
      id: 'prestamos-saldados',
      titulo: 'Préstamos Saldados',
      descripcion: 'Préstamos que han sido completamente pagados',
      icono: '✅',
      ruta: `/${tenantSlug}/reportes/prestamos-saldados`,
      categoria: 'Préstamos'
    },
    {
      id: 'prestamos-realizados',
      titulo: 'Préstamos Realizados',
      descripcion: 'Reporte de préstamos realizados por período',
      icono: '📈',
      ruta: `/${tenantSlug}/reportes/prestamos-realizados`,
      categoria: 'Préstamos'
    },
    {
      id: 'prestamos-rutas',
      titulo: 'Préstamos por Rutas',
      descripcion: 'Distribución de préstamos por ruta de cobro',
      icono: '🚲',
      ruta: `/${tenantSlug}/reportes/prestamos-rutas`,
      categoria: 'Rutas'
    },
    {
      id: 'variaciones-capital',
      titulo: 'Variaciones de Capital',
      descripcion: 'Movimientos y variaciones del capital',
      icono: '📉',
      ruta: `/${tenantSlug}/reportes/variaciones-capital`,
      categoria: 'Finanzas'
    },
    {
      id: 'verificar-compromiso',
      titulo: 'Verificar Compromiso',
      descripcion: 'Verificación de compromisos de pago',
      icono: '✔️',
      ruta: `/${tenantSlug}/reportes/verificar-compromiso`,
      categoria: 'Clientes'
    },
    {
      id: 'buro-credito',
      titulo: 'Buró de Crédito',
      descripcion: 'Historial crediticio de clientes',
      icono: '📄',
      ruta: `/${tenantSlug}/reportes/buro-credito`,
      categoria: 'Clientes'
    }
  ];

  const categorias = ['Todos', 'Pagos', 'Préstamos', 'Clientes', 'Finanzas', 'Rutas'];
  const [categoriaActiva, setCategoriaActiva] = useState('Todos');

  const reportesFiltrados = reportes.filter(reporte => {
    const cumpleCategoria = categoriaActiva === 'Todos' || reporte.categoria === categoriaActiva;
    const cumpleBusqueda = !busqueda ||
      reporte.titulo.toLowerCase().includes(busqueda.toLowerCase()) ||
      reporte.descripcion.toLowerCase().includes(busqueda.toLowerCase());
    return cumpleCategoria && cumpleBusqueda;
  });

  const handleReporteClick = (ruta) => {
    navigate(ruta);
  };

  return (
    <div className="reportes-container">
      <div className="reportes-header">
        <h1>📊 Reportes y Análisis</h1>
        <p>Selecciona un reporte para visualizar información detallada</p>
      </div>

      <div className="reportes-controles">
        <div className="busqueda-reportes">
          <input
            type="text"
            placeholder="Buscar reporte..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            className="input-busqueda"
          />
        </div>

        <div className="categorias-filtro">
          {categorias.map(categoria => (
            <button
              key={categoria}
              className={`btn-categoria ${categoriaActiva === categoria ? 'active' : ''}`}
              onClick={() => setCategoriaActiva(categoria)}
            >
              {categoria}
            </button>
          ))}
        </div>
      </div>

      <div className="reportes-grid">
        {reportesFiltrados.map(reporte => (
          <div
            key={reporte.id}
            className="reporte-card"
            onClick={() => handleReporteClick(reporte.ruta)}
          >
            <div className="reporte-icono">{reporte.icono}</div>
            <div className="reporte-info">
              <h3>{reporte.titulo}</h3>
              <p>{reporte.descripcion}</p>
              <span className="reporte-categoria">{reporte.categoria}</span>
            </div>
            <div className="reporte-arrow">→</div>
          </div>
        ))}
      </div>

      {reportesFiltrados.length === 0 && (
        <div className="sin-resultados">
          <p>No se encontraron reportes que coincidan con tu búsqueda</p>
        </div>
      )}

      <div className="reportes-stats">
        <div className="stat-item">
          <span className="stat-label">Total de Reportes</span>
          <span className="stat-value">{reportes.length}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Mostrando</span>
          <span className="stat-value">{reportesFiltrados.length}</span>
        </div>
      </div>
    </div>
  );
};

export default Reportes;